import {
  Col,
  LinkButton,
  PublicButton,
  Row
} from '@yes.technology/react-toolkit'
import { StyledGrid } from 'shared/style/grid'
import { ActionButtonProps } from './ActionButton.types'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import { getPublicButtonRest, isPublicButton } from 'shared/utils'

function Button({ props }: ActionButtonProps) {
  if (isPublicButton(props)) {
    return (
      <PublicButton
        href={props?.link?.url ?? props?.href}
        target={props?.link?.target ?? props?.target ?? '_self'}
        style={props?.style}
        {...getPublicButtonRest(props)}
      />
    )
  }
  return <LinkButton {...props} />
}

function ActionButton({ props }: ActionButtonProps) {
  const styleProps = useStyleMaps(props.styleMap)
  return (
    <StyledGrid style={styleProps}>
      <Row className='justify-content-center m-0'>
        <Col className='p-0'>
          <Button props={props} />
        </Col>
      </Row>
    </StyledGrid>
  )
}

export default ActionButton
